// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { constants } from "@hardwoods/XDL/constants";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { injectCss } from "@insite/mobius/utilities";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import styled from "styled-components";

export type XngStickyProps = MobiusStyledComponentProps<
    "div",
    {
        css?: StyledProp<XngStickyProps>;
        stickyOffset?: number;
    }
>;

const XngSticky = styled.div<XngStickyProps>`
    position: sticky;
    top: ${({ stickyOffset }) => (stickyOffset ? `${stickyOffset + 20}px` : undefined)};
    ${xScreen.lte("md")} {
        position: static;
    }
    @media print {
        position: static;
    }

    ${injectCss}
`;

XngSticky.defaultProps = {
    stickyOffset: constants.header.size.sticky, // sticky header height
};

export default XngSticky;
